import { render, staticRenderFns } from "./PWAInstallPrompt.vue?vue&type=template&id=045feaa2&scoped=true"
import script from "./PWAInstallPrompt.vue?vue&type=script&lang=js"
export * from "./PWAInstallPrompt.vue?vue&type=script&lang=js"
import style0 from "./PWAInstallPrompt.vue?vue&type=style&index=0&id=045feaa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045feaa2",
  null
  
)

export default component.exports